import { url } from '../../axios/api_urls/dashboard'
const api = require('../../axios/request')
import Vue from 'vue'

const state = {}

const getters = {}

const mutations = {}

const actions = {
    // 本月点击前十产品
    getProductClicke (context, payload) {
        return api._post(url.getProductClicke, payload)
    },
    // 使用趋势TOP10的成分与总计相比
    getInciTrend (context, payload) {
        return api._post(url.getInciTrend, payload)
    },
    // 本月点击前十品牌
    getBrandClicke (context, payload) {
        return api._post(url.getBrandClicke, payload)
    },
    // 年度新产品宣称分布
    getNewLaunchedClaims (context, payload) {
        return api._post(url.getNewLaunchedClaims, payload)
    },
    // 年度新产品数量分布
    getNewProducts (context, payload) {
        return api._post(url.getNewProducts, payload)
    },
    inicFunction (context, payload) {
        return api._post(url.inicFunction, payload)
    },
    yearlist(context, payload) {
        return api._post(url.yearlist, {parentId: 31})
    },
    goodsMarketCategory(context, payload) {
        return api._post(url.goodsMarketCategory, payload)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js